/** Only same-app paths are allowed, so a crafted link can't send users elsewhere. */
export const safeRedirect = (value: string | null): string =>
  value && value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\') ? value : '/';
